// This is a copy of the OrderCancelReason enum from "@redotech/shopify-client/admin.graphql, but that can also be used in redo/model and therefore the frontend
import type { OrderCancelReason } from "@redotech/shopify-client/admin.graphql";
import type { AssertNever } from "@redotech/util/type";

export enum RedoShopifyOrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = "CUSTOMER",
  /** Payment was declined. */
  Declined = "DECLINED",
  /** The order was fraudulent. */
  Fraud = "FRAUD",
  /** There was insufficient inventory. */
  Inventory = "INVENTORY",
  /** The order was canceled for an unlisted reason. */
  Other = "OTHER",
  /** Staff made an error. */
  Staff = "STAFF",
}

type OrderCancelReasonMissingFromRedoEnum = Exclude<
  OrderCancelReason,
  `${RedoShopifyOrderCancelReason}`
>;

/** Breaks the build when Shopify adds an order cancel reason this enum omits. */
export type RedoShopifyOrderCancelReasonCoversShopify =
  AssertNever<OrderCancelReasonMissingFromRedoEnum>;
